import { NgModule } from '@angular/core';
import { FiConnectedDropdownItemsComponent } from '@fi-shared/fi-connected-dropdown-items/fi-connected-dropdown-items.component';
import { MatOption } from '@angular/material/autocomplete';
import { MatPseudoCheckbox } from '@angular/material/core';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        MatOption,
        MatPseudoCheckbox,
        NgForOf,
        NgIf,
        MatIcon,
        MatIconButton,
        MatMenuModule,
    ],
    declarations: [FiConnectedDropdownItemsComponent],
    exports: [FiConnectedDropdownItemsComponent],
})
export class FiConnectedDropdownItemsModule {}
